import React, { useEffect, useState } from 'react'
import { useParams, useNavigate, Link as RouterLink } from 'react-router-dom';
import {
    Card,
    Stack,
    Paper,
    Avatar,
    Button,
    Container,
    Typography,
    IconButton,
    TablePagination,
    ListItemIcon,
    Box,
    TextField,
    Tooltip,
    InputAdornment,
    Grid,
    CardContent,
} from '@mui/material';
import Label from '../../components/label/Label';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { OrdersStatus, NumberFormatter } from '../../utils/helper';
import CircularProgress from '@mui/material/CircularProgress';
import SearchIcon from '@mui/icons-material/Search';
import Pagination from '@mui/material/Pagination';
import { useGetUseDetailtApiQuery, useUserOrdersApiMutation } from '../../redux/services/user/User';

const OrderCard = ({ order, cardNumber, userOrderStatus }) => {
    const { address, landmark, delivery, status, final_amount, created, updated, order_no } = order;
    const createdDate = new Date(created);
    const formattedCreated = createdDate.toLocaleString();

    const updatedDate = new Date(updated);
    const formattedUpdated = updatedDate.toLocaleString();
    return (
        <Card sx={{ display: 'flex', borderLeft: '4px solid green' }}>
            <CardContent sx={{ background: '  #d9e8d9', textAlign: 'center', padding: '14px' }}>
                <Typography variant="h4" color="darkslategray" mt={12}>{cardNumber}</Typography>
            </CardContent>

            <Grid container spacing={2}>
                <Grid item xs={9}>
                    <CardContent>

                        <Box >
                            <Stack direction="row" spacing={3}  >

                                <Stack direction="row" spacing={1}>
                                    <Typography variant="body1" color="gray">Order No:</Typography>
                                    <Typography variant="subtitle2" color="darkslategray">{order_no}</Typography>
                                </Stack>
                                <Stack direction="row" spacing={1} >
                                    <Typography variant="body1" color="gray">created:</Typography>
                                    <Typography variant="subtitle2" color="darkslategray">{formattedCreated} </Typography>
                                </Stack>
                                <Stack direction="row" spacing={1} >
                                    <Typography variant="body1" color="gray">updated:</Typography>
                                    <Typography variant="subtitle2" color="darkslategray"> {formattedUpdated}</Typography>
                                </Stack>

                            </Stack>
                        </Box>
                        <Grid container spacing={2} mt={2}>
                            <Grid item xs={2}>
                                <Typography variant="body1" color="gray">Address:</Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography variant="subtitle2" color="darkslategray">{address}</Typography>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}  >
                            <Grid item xs={2}>

                                <Typography variant="body1" color="gray">Landmark:</Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography variant="subtitle2" color="darkslategray">{landmark}</Typography>
                            </Grid>
                        </Grid>


                        {/* <Divider /> */}
                        <hr />
                        <Grid container spacing={2} mt={1}>
                            <Grid item xs={2}>
                                <Typography variant="body1" color="gray"> Amount:</Typography>

                            </Grid>
                            <Grid item xs={9}>
                                <Typography variant="subtitle2" color="darkslategray"><NumberFormatter number={final_amount} /></Typography>

                            </Grid>
                        </Grid>
                    </CardContent>
                </Grid>
                <Grid item xs={3}>
                    <Box sx={{ display: 'flex', justifyContent: "end", padding: "22px" }}>
                        <Stack direction="row" spacing={2} >
                            <Typography variant="body1" color="gray">Status:</Typography>
                            <Box>
                                <ListItemIcon >
                                    {userOrderStatus(status)}
                                </ListItemIcon>
                            </Box>
                        </Stack>
                    </Box>
                </Grid>
            </Grid>


        </Card >
    );
};

const UserDetails = () => {

    const { id } = useParams()
    const navigate = useNavigate()
    const { data, isLoading } = useGetUseDetailtApiQuery(id)
    const [getUserOrders, loaduserOrders] = useUserOrdersApiMutation()
    const [userOrdersData, setUserOrdersData] = useState([])
    const [details, setDetails] = useState('')
    const [load, setLoad] = useState(false)
    const [totalPage, setTotalPage] = useState(0)
    const [currentPage, setCurrentPaeg] = useState(1)
    console.log("details", details)

    const userOrdersList = async () => {
        const body = {
            id: id,
            page: currentPage,

        }
        const result = await getUserOrders(body)
        setUserOrdersData(result?.data)
    }

    useEffect(() => {
        setLoad(true)
        if (!isLoading) {
            setDetails(data)
            console.log(data);
        }
        userOrdersList()
        setTotalPage(userOrdersData.total)
        setCurrentPaeg(userOrdersData.current)
    }, [data, load, totalPage, currentPage])

    const handlePageChange = (newPage) => {
        setCurrentPaeg(newPage);
    };

    // const handleSearchName = (e) => {
    //     const value = e.target.value;
    //     setSearchByName(value);
    //     if (value.trim() === '') {
    //         setSearchByName('')
    //         userList();
    //     } else {
    //         onUserSearch(searchByMobile, value);
    //     }
    // };

    return (
        <>
            <Box mb={5} mt={2}>
                <Container maxWidth="lx">
                    <Card sx={{ padding: "15px", }} >
                        <Stack direction="row" justifyContent="space-between" mb={1} mt={1}>
                            <Stack direction="row" >
                                <Button onClick={() => navigate(`/user-orders/${id}`)}>
                                    <ArrowBackIcon style={{ color: "blue" }} />
                                </Button>
                                <Typography variant='h4' sx={{ marginTop: "10px" }}>User Detail </Typography>
                            </Stack>


                            <Stack direction="row">
                                <Box m={0.5}>
                                    <TextField
                                        id="outlined-basic"
                                        label="Search Order No"
                                        variant="outlined"
                                        size="small"
                                        // value={searchByMobile}
                                        // onChange={handleSearchMobile}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton aria-label="search"  >
                                                        <SearchIcon sx={{ color: 'blue' }} />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                                <Box mr={3} p={1}>

                                    {
                                        details?.data?.is_active ? <Tooltip title="Active">
                                            <Label color={("" === 'banned' && 'error') || 'success'}>Active</Label>
                                        </Tooltip> : <Tooltip title="DeActive"> <Label color={("" === 'banned' && 'error') || 'error'}>Not Active</Label></Tooltip>
                                    }
                                </Box>
                            </Stack>

                        </Stack>

                    </Card>
                </Container >
                <Container maxWidth="xl">

                    {/* <Box sx={{ padding: "10px", marginTop: "20px" }} > */}

                    <Grid container spacing={2}>
                        <Grid item xs={3}>
                            <Card sx={{ padding: "20px", marginTop: '10px' }}>
                                <Stack direction="row" mb={2}>
                                    <Typography variant="h6">User Info</Typography>
                                </Stack>
                                <Stack direction="row" justifyContent="space-between">
                                    <Box>
                                        <Box>
                                            <Typography variant="subtitle2" color="gray">First Name: </Typography>
                                            <Typography variant="subtitle1">{details?.data?.first_name} {details?.data?.last_name}</Typography>
                                        </Box>

                                        <Box>
                                            <Typography variant="subtitle2" color="gray">Mobile: </Typography>
                                            <Typography variant="subtitle1">{details?.data?.mobile}</Typography>
                                        </Box>
                                        <Box>
                                            <Typography variant="subtitle2" color="gray">Email: </Typography>
                                            <Typography variant="subtitle1">{details?.data?.email}</Typography>
                                        </Box>
                                    </Box>



                                </Stack>
                            </Card>
                        </Grid>
                        <Grid item xs={9}>
                            <Box mt={1.3} >

                                {
                                    loaduserOrders.isLoading ? <Box sx={{ display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box> : (
                                        userOrdersData?.list?.map((item, index) => (
                                            <Box key={item.id} mb={1}>
                                                <OrderCard order={item} cardNumber={index + 1} userOrderStatus={OrdersStatus} />
                                            </Box>
                                        ))
                                    )
                                }


                                <Box mt={3} sx={{ display: 'flex', justifyContent: 'center' }}>
                                    <Pagination
                                        count={totalPage}
                                        page={currentPage}
                                        onChange={handlePageChange}
                                        className="pagination-root" />
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>




                    {/* </Box> */}
                </Container >
            </Box>
            <br />
        </>
    )
}

export default UserDetails
